const emptyFeatureCollection = {
  type: 'FeatureCollection',
  features: []
}

export default emptyFeatureCollection
